  import axios from 'axios';
  // import { HTTP_REQUEST } from '../src/constants';
  import { EventBus } from './EventBusMixin';
  import localStorageService from '../localStorageService/localStorageService';
  import { LOCAL_STORAGE, HTTP_REQUEST } from './constants';
  import 'vue-toastification/dist/index.css';

  // Create an Axios instance
  const instance = axios.create({
    baseURL: HTTP_REQUEST.API_BASE_URL,
    withCredentials: true, // This is important for sending cookies or credentials
    headers: {
        // 'Access-Control-Allow-Origin': '*',
        'accept': 'application/json',
    }
});

  // Request interceptor
  instance.interceptors.request.use(
    (config) => {
      
      if (config.method === 'post' && !config.data) {
        config.data = {}; // Ensure POST requests have a body
      }
      // Retrieve AuthToken from local storage
      const authToken = localStorageService.get(LOCAL_STORAGE.AuthToken);
      if (authToken) {
        config.headers[HTTP_REQUEST.AUTH_TOKEN] = authToken;
      }

      // Add ApiKey if available
      if (HTTP_REQUEST.API_KEY) {
        config.headers['ApiKey'] = HTTP_REQUEST.API_KEY;
      }

      // Set Content-Type with API version
      if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json; x-api-version=0.1';
      }

      // Construct full URL including query params
      const fullUrl = `${config.baseURL}${config.url}${
        config.params ? `?${new URLSearchParams(config.params).toString()}` : ''
      }`;

      // Log the full endpoint
      console.log(`[REQUEST] ${config.method.toUpperCase()} ${fullUrl}`);

      // Debugging: Log the modified config
      // console.dir(config);
      
      return config;
    },
    (error) => {
      // Log and handle request errors
      console.error('Request Error:', error);
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => {
      console.dir(response);
      if(response.data.success){
        EventBus.emit('success' , response.data.message);
      }
      return response;
    },
    (error) => {
      if (error.response) {
        const message = error.response.data.message;
        switch (error.status) {
          case 400:
            // Bad Request
            EventBus.emit('error', message);
            break;
            case 401:
            EventBus.emit('error', message);
            break;
          case 403:
            // Forbidden
            EventBus.emit('error', 'Ni saknar behörighet.');
            break;
          case 404:
            // Not Found
            EventBus.emit('error', 'Kunde inte hitta det ni söker.');
            break;
          case 500:
            // Internal Server Error
            EventBus.emit('error', 'Ett okänt fel uppstod, var snäll och försök senare igen.');
            break;
          case 502:
            // Bad Gateway
            EventBus.emit('error', 'Ett okänt fel uppstod, var snäll och försök senare igen.');
            break;
          case 503:
            // Service Unavailable
            EventBus.emit('error', 'Ett okänt fel uppstod, var snäll och försök senare igen.');
            break;
          case 504:
            // Gateway Timeout
            EventBus.emit('error', 'Ett okänt fel uppstod, var snäll och försök senare igen.');
            break;
          default:
            // Handle other status codes
            EventBus.emit('error', 'Ett okänt fel uppstod, var snäll och försök senare igen.');
        }
      } else if (error.request) {
        // No response was received, likely a network error
        EventBus.emit('error', 'Ett okänt fel uppstod, var snäll och försök senare igen.');
      } else {
        // Something else happened in setting up the request
        EventBus.emit('error', 'Ett okänt fel uppstod, var snäll och försök senare igen.');
      }

      return Promise.reject(error);
    }
  );

  export default instance;
